export type TOtpState = {
  attempt: number
  lastResendAttemptTime: number
  rateLimitLockedTime: number
  isRateLimitReached: boolean
}

export const markAsOtpAttempt = (state: TOtpState) => {
  const currentAttempt = state.attempt

  const nextAttempt = currentAttempt + 1
  state.attempt = nextAttempt
  state.lastResendAttemptTime = Date.now() + nextAttempt * 30000
}

export const resetOtpLimitReached = (state: TOtpState) => {
  state.rateLimitLockedTime = 0
  state.isRateLimitReached = false
}

export const markAsOtpLimitReached = (state: TOtpState, payload: { remainingTime: number }) => {
  state.rateLimitLockedTime = Date.now() + payload?.remainingTime * 1000
  state.isRateLimitReached = true
}

export const unmarkAsOtpLimitReached = (state: TOtpState) => {
  state.rateLimitLockedTime = 0
  state.isRateLimitReached = false
  state.attempt = 0
  state.lastResendAttemptTime = 0
}
